import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-menu-category',
  templateUrl: './menu-category.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./menu-category.component.scss'],
})
export class MenuCategoryComponent {
  @Input() label: string = '';
}
